import React from "react";

interface OnOffSwitchProps {
    checked: boolean;
    onChange: () => void;
};
export const OnOffSwitch = (props: OnOffSwitchProps) => {
    const { checked, onChange } = props;

    return (
        <button
            className={`immersion_admin__on_off_switch ${checked ? 'checked' : ''}`}
            onClick={onChange}
        >
            <div className="immersion_admin__on_off_switch__slider" />
        </button>
    );
};